import LogRocket from 'logrocket'
import setupLogRocketReact from 'logrocket-react'
import LogRocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer'
import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import * as serviceWorker from './serviceWorker'
import * as Sentry from '@sentry/browser'

import './index.css'
import './config/i18n'
import { initGTM } from 'config/gtm'

const { requestSanitizer, responseSanitizer } = LogRocketFuzzySanitizer.setup(['password', 'key', 'token'])

initGTM()

if (process.env.REACT_APP_ENABLE_MONITORING === 'true') {
    LogRocket.init(`${process.env.REACT_APP_LOGROCKET_PROJECT}`, {
        network: {
            requestSanitizer: request => {
                // Remove auth token
                if (request.headers['Authorization']) {
                    request.headers['Authorization'] = '*'
                }
                return requestSanitizer(request as any)
            },
            responseSanitizer: response => responseSanitizer(response as any),
        },
    })
    setupLogRocketReact(LogRocket)

    Sentry.init({
        dsn: `${process.env.REACT_APP_SENTRY_DSN}`,
        environment: `${process.env.ENVIRONMENT}`,
    })

    LogRocket.getSessionURL(sessionURL => {
        Sentry.configureScope(scope => {
            scope.setExtra('sessionURL', sessionURL)
        })
    })
}

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
